<template>
  <div class="flex items-center gap-3.5">
    <!-- report button -->
    <button
      @click="() => changeReportModalState(true)"
      type="button"
      aria-labelledby="Make a report"
      aria-label="Make a report"
      class="py-1 my-5 text-[#FF1F00] bg-transparent !outline-none border-none max-w-max text-[14px] md:text-[15px] lg:text-[16px] xl:text-[17px] 2xl:text-[17.2px] 3xl:text-[17.8px] flex gap-2 items-center font-normal cursor-pointer"
    >
      <ExclimationMark  />
      {{ $t('user.report_product') }}
      <span class="sr-only">{{ $t('user.report_product') }}</span>
    </button>
  </div>
</template>

<script>
import ExclimationMark from "@/assets/shared/icons/ExclimationMark.vue";
import { ShareLink } from "@/components";

export default {
  name: "ReportProduct",
  components: {
    ExclimationMark,
    ShareLink
  },
  props: {
    changeReportModalState: {
      type: Function,
      required: true
    },
  },
};
</script>
